import { useEffect } from "react";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { armSmoothScroll } from "@/components/marketing/site/smooth-scroll";
import { retiredArmHome } from "@/lib/host/host-rewrite";
import { SiteVersionProvider } from "@/lib/marketing/site-version";
/* Here, not beside people-light.css: the sheet carries the arm's tokens, and half the arm's pages
 * never import the PEOPLE shell. */
import "@/styles/people-dark.css";
import "@/styles/people-no-wait.css";
import "@/styles/people-type.css";

/** The server 301s retired `/v2` to ppl-ai.com; this covers client-side navigation on the live
 * host, which the server never sees. */
export const Route = createFileRoute("/v2")({
  beforeLoad: () => {
    if (typeof window === "undefined") return;
    const home = retiredArmHome(new URL(window.location.href));
    if (home) throw redirect({ href: home, replace: true });
  },
  /* The root declares the light --background but this arm is dark (see useDarkArm in __root.tsx),
   * so theme-color follows the ground. */
  head: () => ({
    meta: [{ name: "theme-color", content: "#05060c" }],
  }),
  component: PeopleArm,
});

function PeopleArm() {
  useEffect(() => armSmoothScroll(), []);
  return (
    <SiteVersionProvider version="v2">
      <Outlet />
    </SiteVersionProvider>
  );
}
